'use client';

import { useTranslations } from "@/i18n/client";

export function ContactoHero() {
  const { t } = useTranslations();
  const contacto = t('contacto');

  return (
    <section className="max-w-[var(--container-max)] mx-auto px-6 md:px-14 pt-[72px] pb-12">
      <div className="text-[11px] font-mono tracking-widest uppercase text-[var(--color-mute)]">
        {contacto.overline || 'Hablemos'}
      </div>
      <h1 className="taller-page-title mt-6 max-w-[900px]">
        {contacto.heading || 'Cuéntanos tu '}
        <em className="italic text-[color:var(--color-accent)]">
          {contacto.headingAccent || 'idea'}
        </em>.
        <br />
        {contacto.headingSecondary}
      </h1>
      <p className="font-sans text-[18px] text-[color:var(--color-mute)] leading-[1.55] mt-8 max-w-[520px]">
        {contacto.subtitle || 'Sin pagos iniciales. Sin contratos abusivos. Maqueta en 72 horas y tú decides si seguimos.'}
      </p>
    </section>
  );
}
